<!--
    班级管理-编辑-选中学生
    功能：添加班级学生
-->
<script>
/**
 * @overview 选择学生
 *
 * @author neko
 */

import { form } from '@/mixins';
import defaultBoy from '@/assets/images/student_boy.png';
import defaultGirl from '@/assets/images/student_girl.png';

export default {
  name: 'StudentSelect',

  mixins: [form],

  props: {
    studentSelected: {
      type: Array,
      default: () => [],
    },
    reloadStudent: {
      type: Boolean,
      default: false,
    },
    openPopup: {
      type: Boolean,
      default: false,
    },
    centerDialogVisible: {
      type: Boolean,
      default: false,
    },
    importStudents: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      moveErrorBoy: `this.src="${defaultBoy}"`,
      moveErrorGirl: `this.src="${defaultGirl}"`,
      list: {},
      studentCol: [
        { prop: 'name', label: '学生' },
        { prop: 'number', label: '学号' },
        { prop: 'mobile', label: '电话' },
        {
          label: '性别',
          width: '80px',
          formatter: row => (row.gender === 1 ? '男' : '女'),
        },
        { prop: 'created_at', label: '注册时间' },
      ],
      oldPage: {
        page: 1,
        per_page: 10,
        'order[id]': 'desc',
      },
      searchObj: {
        page: 1,
        per_page: 10,
        'order[id]': 'desc',
      },
      inputValue: '',
      selectValue: '',
      currSelectList: [],
      // 控制页面加载状态
      loading: false,
      selectData: [],
    };
  },

  computed: {
    selectWidth() {
      const maxLength = Math.max(
        ...this.searchList.map(({ label }) => label.length),
      );

      return `${maxLength + 4}em`;
    },

    searchList() {
      return [
        { prop: 'name', label: '学生名称' },
        { prop: 'mobile', label: '电话' },
      ];
    },
  },

  watch: {
    importStudents(val) {
      if (val) {
        this.getStudentList();
      }
    },
    list() {
      this.currSelectList = [];
    },
    openPopup(val) {
      if (val) {
        this.$refs.multipleTable.clearSelection();
      }
    },
    reloadStudent(val) {
      if (val) {
        this.getStudentList();
      }
    },
    centerDialogVisible(val) {
      if (!val) {
        this.getStudentList();
      }
    },
  },

  created() {
    this.getStudentList();
  },

  methods: {
    initPage() {
      this.searchObj = {
        page: 1,
        per_page: 10,
        'order[id]': 'desc',
      };
    },
    getStudentList(page) {
      this.loading = true;
      this.searchObj = {
        page: page ? 1 : this.searchObj.page,
        per_page: this.searchObj.per_page,
        'order[id]': this.searchObj['order[id]'],
      };

      if (this.selectValue) {
        this.searchObj[`like[${this.selectValue}]`] = this.inputValue;
      }
      const query = Object.keys(this.searchObj)
        .map(key => `${key}=${this.searchObj[key]}`)
        .join('&');

      this.$http
        .get(`/api/student?${query}`)
        .then((data) => {
          this.list = data;
          setTimeout(() => {
            this.toggleSelection();
          }, 0);
        })
        .catch(() => {
          this.$message.error('数据请求发生错误');
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onSizeChange(per_page) {
      this.oldPage = this.searchObj;
      this.searchObj = {
        ...this.searchObj,
        page: 1,
        per_page,
      };

      this.getStudentList();
    },

    onCurrentChange(page) {
      this.oldPage = this.searchObj;
      this.searchObj = {
        ...this.searchObj,
        page,
      };

      this.getStudentList();
    },

    toggleSelection() {
      const selectedList = this.studentSelected;
      if (selectedList.length > 0) {
        const selectedIndex = [];
        for (let i = 0; i < selectedList.length; i++) {
          for (let j = 0; j < this.list.items.length; j++) {
            if (this.list.items[j].id === selectedList[i].id) {
              selectedIndex.push(j);
            }
          }
        }
        selectedIndex.forEach((index) => {
          this.$refs.multipleTable.toggleRowSelection(this.list.items[index * 1], true);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    getSelectList(val) {
      const studentLength = this.currSelectList.length;
      const length = val.length;
      // 将选择到的学生数存入sotre中
      this.$store.commit('setLength', val.length);

      if (studentLength > length) {
        this.delStudent(val);
      }

      if (studentLength < length) {
        this.addStudent(val);
      }

      this.currSelectList = val;
    },

    addStudent(val) {
      val.forEach((item) => {
        const student = this.studentSelected.find(
          valItem => item.id === valItem.id,
        );

        if (!student) {
          this.studentSelected.push(item);
        }
      });

      this.sendStudentList();
    },
    delStudent(val) {
      this.currSelectList.forEach((item) => {
        const student = val.find(selItem => item.id === selItem.id);

        if (!student) {
          const delIndex = this.studentSelected.findIndex(
            totalItem => item.id === totalItem.id,
          );

          this.studentSelected.splice(delIndex, 1);
        }
      });

      this.sendStudentList();
    },

    sendStudentList() {
      this.$emit('studentList', this.studentSelected);
    },
  },
};
</script>

<template>
  <div
    v-loading="loading"
    class="student-select">
    <div class="student-select__search">
      <el-input
        v-model="inputValue"
        class="student-select__input"
        placeholder="请输入关键字进行搜索"
        size="small"
        @keyup.enter.native="getStudentList('changePage')"
      >
        <el-select
          slot="prepend"
          v-model="selectValue"
          :style="{ width: selectWidth }"
          placeholder="请选择"
        >
          <el-option
            v-for="column in searchList"
            :key="column.prop"
            :label="column.label"
            :value="column.prop"
          />
        </el-select>
      </el-input>

      <el-button
        slot="append"
        icon="el-icon-search"
        size="small"
        class="student-select__button"
        @click="getStudentList('changePage')"
      />
    </div>

    <div style="clear:both;"/>

    <div
      v-if="studentSelected.length > 0"
      class="student-select__selected">
      <el-tag
        v-for="tag in studentSelected"
        :key="tag.id">{{ tag.name }}</el-tag>
    </div>

    <!-- @select="getSelectList" -->
    <el-table
      ref="multipleTable"
      :data="list.items"
      @selection-change="getSelectList">
      <el-table-column
        type="selection"
        width="55"/>
      <el-table-column
        width="80px"
        label="头像">
        <template slot-scope="scope">
          <img
            :src="scope.row.headimgurl ? scope.row.headimgurl : ''"
            :onerror="scope.row.gender === 1 ? moveErrorBoy : moveErrorGirl"
            class="head_url"
            alt="">
        </template>
      </el-table-column>
      <el-table-column
        v-for="col in studentCol"
        :key="col.prop"
        :prop="col.prop"
        :label="col.label"
        :width="col.width"
        :formatter="col.formatter"
      />
    </el-table>

    <footer class="student-select__footer">
      <el-pagination
        v-if="list.meta && list.meta.total > 10"
        :current-page="list.meta.current_page"
        :page-sizes="[10, 20, 50, 100, 500]"
        :page-size="10"
        :total="list.meta.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="onSizeChange"
        @current-change="onCurrentChange"
      />
    </footer>
  </div>
</template>

<style lang="scss" scoped>
.student-select {
   /deep/ .el-table{
    margin-top: 15px;
  }
  .student-select__search {
    width: 370px;
    float: right;
  }
  .student-select__input {
    width: 300px;
  }
  .student-select__selected {
    max-height: 150px;
    overflow: auto;
    margin: 20px 0;
  }
  .student-select__selected {
    .el-tag {
      margin: 5px 5px 0 0;
    }
  }
  .student-select__footer {
    padding: 2em 0 1em;
    margin-top: auto;
  }
  .head_url {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ClassManage/StudentSelect.vue